import { ReducerAction, ReducerHandler } from '../../Types';
import { StoreI18n } from '../../Types/StoreTypes';
import { SET_I18N, SET_SELECTED_LANGUAGE } from '../Actions/i18nActions';

const initialState = {
    i18n: null,
    selectedLanguage: 'de',
} as StoreI18n;

const i18nReducerMap: Record<string, ReducerHandler<StoreI18n>> = {
    [SET_I18N]: (state, action) => ({ ...state, i18n: action.payload }),
    [SET_SELECTED_LANGUAGE]: (state, action) => ({ ...state, selectedLanguage: action.payload }),
};

function i18nReducer(state = initialState, action: ReducerAction): StoreI18n {
    const handler = i18nReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default i18nReducer;
